import { connectedStore } from '../../store';
import createScript from '../../utils/create-script';
import selectors from '../selectors';
import constants from '../constants';
import getPlaceToInsertSiteDependencies from '../helpers/get-place-to-insert-site-dependencies';

const withSiteDependencies = (liveDocument) => {
  const store = connectedStore.get();
  const state = store.getState();
  const dependencies = selectors.getDependencies(state);

  if (!dependencies) return;

  const { position, element } = getPlaceToInsertSiteDependencies(liveDocument);

  dependencies.forEach((dependency) => {
    if (liveDocument.querySelector(`script[src="${dependency.source}"]`)) return;
    const script = createScript(liveDocument, dependency.source);
    script.setAttribute(constants.attributes.SITE_DEPENDENCY_ATTRIBUTE, '');
    element.insertAdjacentElement(position, script);
  });
};

export default withSiteDependencies;
